import { useTranslation } from 'react-i18next';
import { CheckedIcon } from '../../assets/icons/CheckedIcon';
import DollarIcon from '../../assets/icons/DollarIcon';
import EmailIcon from '../../assets/icons/EmailIcon';
import LocationIcon from '../../assets/icons/LocationIcon';

export default function Services() {
  const { t } = useTranslation();
  const services = [
    {
      title: "serv-1",
      detail: "det-serv-1",
      img: <CheckedIcon />
    },
    {
      title: "serv-2",
      detail: "det-serv-2",
      img: <DollarIcon />
    },
    {
      title: "serv-3",
      detail: "det-serv-3",
      img: <EmailIcon />
    },
    {
      title: "serv-4",
      detail: "det-serv-4",
      img: <LocationIcon />
    },
  ];
  return (
    <section className="container py-10 relative">
      <div className="w-full ">
        <div className="w-full flex-col justify-start items-center lg:gap-11 gap-8 inline-flex">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 justify-start items-start gap-8">
            {
              services.map((item, index) => (
                <div key={index} className="h-full group hover:bg-blue-600 w-full shadow-sm px-6 py-8 rounded-2xl myborder flex justify-center items-center gap-2.5">
                  <div className="flex-col justify-start items-center gap-3.5 inline-flex">
                    {item.img ? item.img : null}
                    <h4 className="text-center text-black group-hover:text-white text-lg font-semibold leading-8">{t(item.title)}</h4>
                    <p className="text-center text-gray-500 group-hover:text-white text-sm font-normal leading-snug">{t(item.detail)}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </section>

  )
}
